import Button from 'components/Button/Button';
import Title from 'components/Title/Title';
import withContactPageQuery, { IWithContactPageQueryProps } from 'enhancers/withContactPageQuery';
import withCountry from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

type Props = IWithContactPageQueryProps & WithLanguageProps;

export const ContactPage: React.SFC<Props> = props => {
  const query = props.contactQuery;
  const background =
    !query.loading &&
    query.data &&
    query.data.fetch.Common.Contact &&
    query.data.fetch.Common.Contact.BackgroundColor
      ? query.data.fetch.Common.Contact.BackgroundColor
      : '#ffffff';
  const color =
    !query.loading &&
    query.data &&
    query.data.fetch.Common.Contact &&
    query.data.fetch.Common.Contact.TitleColor
      ? query.data.fetch.Common.Contact.TitleColor
      : getTextColor(background);

  return (
    <Container style={{ background, color }}>
      <div>
        <StyledTitle>
          {!query.loading &&
            query.data &&
            props.getText(
              query.data.fetch.Country.ContactPage &&
                query.data.fetch.Country.ContactPage.Header
            )}
        </StyledTitle>
        <Markdown
          source={props.getText(
            !query.loading &&
              query.data &&
              query.data.fetch.Country.ContactPage &&
              query.data.fetch.Country.ContactPage.Content
          )}
        />
        {!query.loading &&
          query.data &&
          query.data.fetch.Country.ContactPage &&
          query.data.fetch.Country.ContactPage.ShowContactButton !== 'no' && (
            <MailButton
              external={true}
              link={`mailto:${!query.loading &&
                query.data &&
                query.data.fetch.Country.ContactPage &&
                query.data.fetch.Country.ContactPage.ContactEmail}`}
            >
              {!query.loading &&
                query.data &&
                query.data.fetch.Country.ContactPage &&
                props.getText(query.data.fetch.Country.ContactPage.SendText)}
            </MailButton>
          )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 100px;
  text-align: center;
  min-height: calc(100vh - 300px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MailButton = styled(Button)`
  font-size: 18px;
  margin-top: 20px;
`;

const StyledTitle = styled(Title)`
  text-align: center;
  margin: 0;
  font-size: 85px;
  @media (max-width: 800px) {
    font-size: 35px;
  }
`;

export default withLanguageState(
  withCountry(withContactPageQuery(ContactPage))
);



// WEBPACK FOOTER //
// ./src/pages/ContactPage/ContactPage.tsx